// @ts-nocheck
import { observable, computed, action } from "mobx";

// Utils Stores
import { EInternalEvents } from "../InternalEventsStore/InternalEventsStore";

// Util
import { dynamicSortByProperty } from "../../utils/SortUtils/SortUtils";
import { didSearchList } from "../../utils/Utils";

class InformativeClocksStore {
  @observable dataList = [];
  @observable isFetching = false;
  @observable searchString = "";

  constructor(
    internalEventsStore,
    resourcesStore,
    notificationsStore,
    modboxAPIService
  ) {
    this.resourcesStore = resourcesStore;
    this.notificationsStore = notificationsStore;
    this.modboxAPIService = modboxAPIService;

    internalEventsStore.subscribeTo({
      eventKey: EInternalEvents.didChangeSelectedContract,
      observer: this,
      callback: this.clearStore,
    });

    internalEventsStore.subscribeTo({
      eventKey: EInternalEvents.didLogout,
      observer: this,
      callback: this.clearStore,
    });
  }

  @action
  clearStore = () => {
    this.isFetching = false;
    this.dataList = [];
    this.searchString = "";
  };

  @action
  setIsFetching = (newValue) => {
    this.isFetching = newValue;
  };

  @action
  setDataList = (newValue) => {
    this.dataList = newValue;
  };

  @action
  setSearchString = (searchString) => {
    this.searchString = searchString;
  };

  @computed
  get filteredDataList() {
    if (this.searchString.length > 0) {
      return didSearchList(
        this.searchString,
        this.dataList,
        (clock, textIncludesSearchString) =>
          textIncludesSearchString(clock.label)
      );
    }

    return this.dataList;
  }

  @action
  getDataList = (withFetchingAnimation = true) => {
    this.setIsFetching(withFetchingAnimation);
    let newList = [];

    this.modboxAPIService
      .requestClocks()
      .then((response) => {
        if (response.status === 200) {
          response.data.clocks.forEach((clock) => {
            newList.push({
              label: clock.label,
              ledArea: clock.led_area,
              backgroundColor: `#${clock.background_color}`,
              fontColor: `#${clock.font_color}`,
              token: clock.clock_token,
              isTransparent: clock.transparent === "True",
              isVertical: clock.orientation === "90",
            });
          });
        }

        this.setDataList(newList.sort(dynamicSortByProperty("label")));

        this.setIsFetching(false);
      })
      .catch((error) => {
        window.debugError("error in requestClocks", error);
        if (error && error.statusCode === 429) {
          setTimeout(this.getDataList, 2000);
        }
      });
  };

  refreshResourcesStore = () => {
    this.resourcesStore.getResourceRulesList("clock", false);
  };

  submit = (clock) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .submitClock(clock)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: this.i18nStore.localizedString({
              id: "Schedule@readyToCreateRulesMessage",
              defaultString:
                "Configure uma regra para começar a utilizar o recurso.",
            }),
            color: "success",
          });
          this.getDataList(false);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  update = (clock) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .updateClock(clock)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: response.data.message,
            color: "success",
          });
          this.getDataList(false);
          this.refreshResourcesStore();
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  delete = (clock) => {
    return new Promise((resolve, reject) => {
      this.modboxAPIService
        .deleteClock(clock)
        .then((response) => {
          this.notificationsStore.addSnackbarNotification({
            message: response.data.message,
            color: "success",
          });
          this.getDataList(false);
          this.refreshResourcesStore();
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  getWithToken = (token) => {
    if (this.dataList.length > 0) {
      return this.dataList.find((group) => group.token === token);
    }
    return null;
  };
}

export default InformativeClocksStore;
